import { CaseManagementState } from "./types";

export function getDefaultState(): CaseManagementState {
    return {
        caseTypes: [],
        caseTypesForUser: []
    }
}